module.exports = __webpack_public_path__ + "img/footer_logo.9ec6256b.svg";